module.exports = __webpack_public_path__ + "static/poster-4329340455788c15e0d1499ddde5d8ca.jpg";